import { ArrowRight } from '@phosphor-icons/react'
import { Link } from 'react-router-dom'
import { Text } from '../../../../Components/Screen/Text/Body'
import { Heading, Subheading } from '../../../../Components/Screen/Text/Heading'
import { CountStats } from './CountStats'
import { ImageContainer } from './imageContainer'

export const Market = () => {
  return (
    <section id="marketplace" className="w-full h-full flex flex-col gap-10">
      <CountStats />
      <div className="flex flex-col text-center">
        <Subheading>
          Acesso ao mundo de NFTs para sua fazenda física.
        </Subheading>
        <Heading className="text-laranjaClaro">
          NFTs com certificado
          <Heading> em nosso </Heading>
          Marketplace.
        </Heading>
      </div>
      <div className="relative flex items-center justify-center w-full">
        <ImageContainer />
      </div>
      <Link
        to="/marketplace"
        className="sm:hidden flex w-full items-center justify-center gap-2"
      >
        <Text className={'text-center text-white'}>Marketplace</Text>
        <ArrowRight size={24} className="text-laranjaClaro" weight="bold" />
      </Link>
    </section>
  )
}
